<template>
    <div class="steps bg-darkest lightest text-center">
        <ul class="d-flex align-items-center">
            <li
                class="d-flex align-items-center lightest p-3 m-2"
                v-for="step in steps"
                @click="switchStep($event, step)"
                :class="{ active: (step.number === currentStep), pointer: editing }">
                    <span class="number radius-circle">{{ step.number }}</span>
                    <span>{{ step.label }}</span>
            </li>
        </ul>
    </div>

</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        props: {
            currentStep: Number,
        },
        data: function() {
            return {
                steps: [
                    { number: 1, label: 'Details', path: '' },
                    // { number: 2, label: 'Prices', path: 'prices' },
                    { number: 2, label: 'Schedule', path: 'schedule' },
                    { number: 3, label: 'Extras', path: 'extras' },
                    // { number: 4, label: 'Resources', path: 'resources' },
                    { number: 4, label: 'Sales Channels', path: 'channels' },
                    { number: 5, label: 'Pick-ups', path: 'pickups' },
                    // { number: 4, label: 'Payment details', path: 'payments' },
                ]
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedItem',
            ]),
            editing: function() {
                return this.getSelectedItem ? true : false;
            }
        },
        methods: {
            switchStep: function(event, step) {
                if (this.getSelectedItem) {
                    this.$emit('switchStep', step.number);
                }
            }
        }
    }
</script>

<style lang="scss">
.steps{
    height: 4.5rem;
}
</style>



// WEBPACK FOOTER //
// ProductSteps.vue?1608832e